import { Component } from '@angular/core';

@Component({
    selector: 'gl-travelcards-and-tickets-page',
    templateUrl: './travelcards-and-tickets-parent-page.component.html',
    styleUrls: ['./travelcards-and-tickets-parent-page.component.scss']
})
export class TravelcardsAndTicketsParentPageComponent {}
